"use client";

import React from "react";

interface SimpleButtonProps {
  label?: string;
  onClick?: () => void;
}

// This is a simple client component that should NOT be dynamically imported
// It's lightweight and likely used throughout the app
const SimpleButton: React.FC<SimpleButtonProps> = ({
  label = "Click me",
  onClick,
}) => {
  const [clicked, setClicked] = React.useState(false);

  const handleClick = () => {
    setClicked(true);
    onClick?.();
    setTimeout(() => setClicked(false), 500);
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow border">
      <h3 className="text-lg font-semibold mb-3 text-gray-800">
        Simple Interactive Button
      </h3>
      <p className="text-sm text-gray-600 mb-4">
        This is a lightweight component that should be in the main bundle
      </p>

      <button
        onClick={handleClick}
        className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
          clicked
            ? "bg-green-500 text-white scale-95"
            : "bg-blue-500 hover:bg-blue-600 text-white hover:scale-105"
        }`}
      >
        {clicked ? "✓ Clicked!" : label}
      </button>

      <div className="mt-4 p-3 bg-orange-50 rounded-lg">
        <h4 className="font-semibold text-orange-800 mb-2">
          ❌ Don&apos;t Dynamic Import:
        </h4>
        <ul className="text-sm text-orange-700 space-y-1">
          <li>• Small, lightweight components</li>
          <li>• Core UI elements used everywhere</li>
          <li>• Components without heavy dependencies</li>
          <li>• Critical user interface elements</li>
        </ul>
      </div>
    </div>
  );
};

export default SimpleButton;
